import React, { Component } from 'react';
import { connect } from 'react-redux';
import {placeMakerOrder,placeTakerOrder} from '../../../../actions/orderbook/set';
import {matchOrders} from '../../../../actions/orderbook/matchingEngine';
import {setAmount,setPrice} from '../../../../actions/ui/marketplace';
import M from 'materialize-css/dist/js/materialize.min.js'
import {reduxForm,Field} from 'redux-form';
import renderInput from '../../../helper/input';
import Modal from '../../../helper/modal';
import Loader from '../../../helper/loader';

import TakeOrders from './takingOrders';
import $ from 'jquery';
import Balance from './balance.jsx';
import { Link } from 'react-router-dom';
import {toUnit,fromUnit, multiplyCurrency} from '../../../../config';
import {setTradeAddress} from '../../../../actions/ui/marketplace';
import TradeAddresses from './tradeAddresses';
import {Decimal} from 'decimal.js'

class CreateOrder extends Component {
  constructor(){
    super()
    this.state = {loaded:false,showChecking:true};
  }
  renderModal(){
    return (
      <Modal id='modal2' style={{maxWidth:'500px'}} noClose={true} title={'Trade Confirmation'} classes='modal modalOrders black-text' component={(<TakeOrders/>)} isOrder={true} chain={'BSEC'} decryption={true} buttonText={"Confirm"} buttonAction={this.submitOperation.bind(this)} />
    )
  }
  round(num){
    return num
  }
  onChangeAmount(e){
    let val = e.target.value;
    this.props.setAmount(val,()=>{});
    // this.props.matchOrders();
  }
  onChangePrice(e){
    let val = e.target.value;
    this.props.setPrice(val,()=>{});
    // this.props.matchOrders();
  }
  render() {
    const { handleSubmit } = this.props;

    let curr1 = this.props.market.asset
    let curr2 = this.props.market.denomination

    let priceName = `Price (${curr2})`;
    let amountName = `Amount (${curr1})`;
    let color = this.props.orderType === "BUY" ? "#65ad61" : '#de7272';

    let disabled;
    if(!this.props.wallet[curr1.toLowerCase()]){
      disabled = false;
    }
    else {
      disabled = Object.keys(this.props.wallet[curr1.toLowerCase()]).length === 0;
      if(!disabled) disabled = Object.keys(this.props.wallet[curr2.toLowerCase()]).length === 0;
    }

    let total = null
    try {
      total = new Decimal(this.props.price).mul(new Decimal(this.props.amount)).toNumber()
    } catch (e) {
      total = 0;
    }

    let label2Price = this.props.price && this.props.amount ? `= ${total} ${curr2}` : null

    return (
      <div>
        {this.renderModal()}
        <form onSubmit={handleSubmit(this.handleFormSubmit.bind(this))} >
          <div className="row">
            <Field name="price" _id='price' onChang={this.onChangePrice.bind(this)} component={renderInput} type="number" label={`${priceName.replace('NRG','OL')}`}  required={true} min={0} />
            <Field name="amount" _id='amount' onChang={this.onChangeAmount.bind(this)} component={renderInput} type="number" label={`${amountName}`} label2={''} required={true} />
          </div>
          <Balance />

          <div style={{paddingBottom:'0px',paddingTop:'10px'}}>
            <div className='col s4' style={{padding:0}}>
              {this.props.loading === 'order' ? <Loader/> :
              <button disabled={disabled} style={{padding:0,width:'80px',marginBottom:'5px',height:'28px',lineHeight:'28px',fontSize:'12px'}} action="submit" className={this.props.orderType === "BUY" ? "btn clickables" : "btn clickablesRed"} >{this.props.orderType} {curr1}</button>
              }
            </div>

            <div className='col s8' style={{padding:0,height:'32px',marginBottom:'10px'}}>
              <div style={{}}>
                {disabled && this.renderPleaseUpload()}
                {!disabled && <TradeAddresses tradeAddresses={this.props.tradeAddresses}/>}
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
  setAddress(chain,addr){
    this.props.setTradeAddress(chain,addr,()=>{
    })
    return
  }
  renderPleaseUpload(){

    let curr1 = this.props.market.asset
    let curr2 = this.props.market.denomination

    let wallet1 = Object.keys(this.props.wallet[curr1.toLowerCase()]).length === 0;
    let wallet2 = Object.keys(this.props.wallet[curr2.toLowerCase()]).length === 0;

    return (
      <p className='choosedate grey-text' style={{fontSize:'0.65rem',padding:0,margin:0}}>
        {wallet1 &&
          <Link to='/' style={{marginBottom:'2px',color:'grey'}}>
            Upload Your {curr1.toUpperCase()} Address
            <br/>
          </Link>
        }

        {wallet2 &&
          <Link to='/' style={{marginBottom:'2px',color:'grey'}}>
            Upload Your {curr2.toUpperCase()} Address
          </Link>
        }
      </p>
    )
  }
  async submitOperation(){
     let password = $("#password").val();
     let noError = true;
     this.setState({showChecking:true})
     setTimeout(()=>{
       if(this.state.showChecking) {
         M.toast({html: 'Submitting Transaction',classes:"grey",displayLength:3000});
         var instance = M.Modal.getInstance(document.querySelectorAll('#modal2')[0]);
         if(instance) instance.close();
       }
     },50);

     for(let order of this.props.takeOrders) {
       await this.props.placeTakerOrder({password,order},(err,hash)=>{
         if(!err) {
         }
         else {
           noError = false;
           M.toast({html: err,classes:"red",displayLength:3000});
           if(instance) instance.open();
           this.setState({showChecking:false})
         }
       });
     }

     if(this.props.makerAmount > 0){
       await this.props.placeMakerOrder({password},(err,hash)=>{
         if(!err) {
         }
         else {
           noError = false;
           M.toast({html: err,classes:"red",displayLength:3000});
           if(instance) instance.open();
           this.setState({showChecking:false})

         }
       });
     }

     if(noError){
       this.props.setAmount('',()=>{});
       this.setState({showChecking:false})
       // this.props.setPrice('',()=>{});
       // this.props.matchOrders({amount:0,price:0});
       if($('#password')) $("#password")[0].value = '';
       // $('#price')[0].value = '';
       if($('#amount')) $('#amount')[0].value = '';
       setTimeout(()=>{
         M.toast({html: 'Transaction Submitted!',classes: "green",displayLength:3000});
       },100)
       var instance = M.Modal.getInstance(document.querySelectorAll('#modal2')[0]);
       if(instance) instance.close();
     }
  }
  componentDidMount(){
    let market = this.props.market.asset+'/'+this.props.market.denomination
    let val = this.props.stats ? this.props.stats[this.props.market.type][market].lastPrice.price : null;
    if(!val) val = new Decimal(this.props.prices[this.props.market.asset.toLowerCase()]).div(new Decimal(this.props.prices[this.props.market.denomination.toLowerCase()])).toString().substring(0,10)
    if($('#price')) $('#price')[0].value = val;
    this.props.setPrice(val,()=>{});
  }
  componentDidUpdate(prevProps){
    let market = this.props.market.asset+'/'+this.props.market.denomination
    let oldMarket = prevProps.market.asset+'/'+prevProps.market.denomination

    if(market != oldMarket || this.state.loaded === false){
      let val = this.props.stats ? this.props.stats[this.props.market.type][market].lastPrice.price : null;
      if(!val) val = new Decimal(this.props.prices[this.props.market.asset.toLowerCase()]).div(new Decimal(this.props.prices[this.props.market.denomination.toLowerCase()])).toString().substring(0,10)
      if($('#price')) $('#price')[0].value = val;
      this.props.setPrice(val,()=>{});
      this.setState({loaded:true})
    }
  }
  handleFormSubmit() {
    this.props.matchOrders(()=>{
      if(this.props.matching) return;
      if(this.props.nrg && this.props.takeOrders.length == 0 && this.props.orderType == 'SELL'){
        M.toast({html: 'No sell order exists for the specified price',classes:"red",displayLength:3000});
        return;
      }
      if(this.props.makerAmount > 0 && this.props.makerCollateral == 0){
        M.toast({html: 'Cannot place order with 0 NRG as collateral',classes:"red",displayLength:3000});
        return;
      }
      if(this.props.amount <= 0 || this.props.price <= 0){
        M.toast({html: 'Price and Amount must be above 0',classes:"red",displayLength:3000});
        return;
      }
      // console.log(this.props)
      if(this.props.makerAmount === 0 && this.props.takeOrders.length === 0){
        M.toast({html: 'Cannot make an order with these params',classes:"red",displayLength:3000});
        return;
      }
      setTimeout(()=>{
        var instance = M.Modal.getInstance(document.querySelectorAll('#modal2')[0]);
        instance.open();
        setTimeout(()=>{
          if($("#password")) $("#password").focus()
        },100)
      },100);
    });
  }
}

CreateOrder = reduxForm({
  form: 'createOrder',  // name of the form
})(CreateOrder);

function mapStateToProps(state) {
  let { denomination, asset, type } = state.ui_marketplace.market;
  let sendsFromChain =
    state.ui_marketplace.orderType === "BUY" ? denomination : asset;
  let receivesToChain =
    state.ui_marketplace.orderType === "BUY" ? asset : denomination;
  let price = state.ui_marketplace.price ? state.ui_marketplace.price : 0;

  let makerAmount = state.ui_marketplace.makerAmount;

  let receivesUnit =
    state.ui_marketplace.orderType == "BUY"
      ? makerAmount
      : new Decimal(makerAmount)
          .mul(new Decimal(price))
          .toNumber();
  let sendsUnit =
    state.ui_marketplace.orderType == "SELL"
      ? makerAmount
      : new Decimal(makerAmount)
          .mul(new Decimal(price))
          .toNumber();

  sendsUnit = fromUnit(sendsFromChain.toLowerCase(),Math.floor(toUnit(sendsFromChain.toLowerCase(),sendsUnit)))
  receivesUnit = fromUnit(receivesToChain.toLowerCase(),Math.floor(toUnit(receivesToChain.toLowerCase(),receivesUnit)))

  if(sendsUnit === 0 || receivesUnit === 0) {
    makerAmount = 0;
  }

  return {
    matching: state.ui_marketplace.matching,
    nrg: state.ui_marketplace.market.denomination == 'NRG' || state.ui_marketplace.market.asset == 'NRG',
    loading: state.ui_passport.loading,
    stats: state.orderbook.stats,
    market: state.ui_marketplace.market,
    price: state.ui_marketplace.price,
    amount: state.ui_marketplace.amount,
    wallet: state.passport.wallet,
    orderType: state.ui_marketplace.orderType,
    takeOrders: state.ui_marketplace.takeOrders,
    prices: state.price,
    makerAmount,
    makerCollateral: state.ui_marketplace.makerCollateral,
    takerCollateral: state.ui_marketplace.takerCollateral
  }
}

export default connect(mapStateToProps,{setTradeAddress,setAmount,placeMakerOrder,placeTakerOrder, setPrice,matchOrders})(CreateOrder);
